<script setup lang="ts">
import type { SearchItemProps } from "@/dsComponents/QuickActions/types";

// biome-ignore lint/correctness/noUnusedVariables: Init Biome
const props = withDefaults(defineProps<SearchItemProps>(), {
    selected: false,
});

const emit = defineEmits(["click"]);
</script>

<template>
    <div :class="['search-result-item', { 'search-result-item--selected': selected }]" @click="emit('click')">
        <div class="search-result-item__infos">
            <slot name="infos" />
        </div>

        <div class="search-result-item__more-infos">
            <slot name="more-infos" />
        </div>

        <div class="search-result-item__details">
            <slot name="first-details" />
        </div>

        <div class="search-result-item__details">
            <slot name="second-details" />
        </div>

        <div v-if="$slots.actions" class="search-result-item__actions">
            <slot name="actions" />
        </div>
    </div>
</template>

<style scoped lang="scss">
.search-result-item {
    display: flex;
    align-items: center;
    height: 44px;
    overflow: hidden;
    padding: 0 var(--spacing-lg, 12px);
    border-radius: var(--radius-sm, 6px);
    border: 1px solid transparent;
    cursor: pointer;
    width: 100%;

    &:hover {
        background-color: var(--bg-lightest-50, #f6f7f9);

        .search-result-item__more-infos {
            color: var(--text-main-900, #00061a);
        }
    }

    &--selected {
        border-color: var(--stroke-soft-200, #dbdfe6);
        background-color: var(--bg-weak-100, #eff2f5);

        .search-result-item__more-infos {
            color: var(--text-main-900, #00061a);
        }
    }

    &__infos {
        display: flex;
        align-items: center;
        gap: var(--spacing-lg, 12px);
        padding: 0 var(--spacing-xxs, 2px);
        flex: 1;
        min-width: 0;
    }

    &__more-infos {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: var(--spacing-xs, 4px);
        width: 200px;
        padding: 0 var(--spacing-xxs, 2px);
        color: var(--text-sub-600, #494e61);
    }

    &__details {
        display: flex;
        align-items: center;
        flex-shrink: 0;
        gap: var(--spacing-xs, 4px);
        width: 64px;
        padding: 0 var(--spacing-xxs, 2px);
    }

    &__actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-shrink: 0;
        width: 96px;
        padding: 0 var(--spacing-xxs, 2px);
    }
}
</style>
